import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import _moment from 'moment';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SectorReportsService {
  constructor(private _http: HttpClient) {}

  getSectorReports(request: any): Observable<any> {
    return this._http.get<any>(
      `https://test.reports.brainyinteligencia.com/templates/${request.id}/reports?page=${request.page}&size=${request.size}`
    );
    // return of(this.getFakeSectorReports()).pipe(delay(1000));
  }

  getSectorReport(request: any): Observable<any> {
    return this._http.get<any>(
      `https://test.reports.brainyinteligencia.com/templates/${request.idTemplate}/reports/${request.id}`
    );
    // return of(this.getFakeSectorReport()).pipe(delay(1000));
  }

  getSources(request: any): Observable<any> {
    if (request.categoryId && request.categoryId != 0 && request.categoryId != 'create') {
      return this._http.get<any>(
        `https://test.reports.brainyinteligencia.com/sources?page=${request.page}&size=${request.size}&category_id=${request.categoryId}`
      );
    } else {
      return this._http.get<any>(
        `https://test.reports.brainyinteligencia.com/sources?page=${request.page}&size=${request.size}`
      );
    } // return of(this.getFakeSources()).pipe(delay(1000));
  }

  getSourcesLatests(request: any): Observable<any> {
    return this._http.get<any>(
      `https://test.reports.brainyinteligencia.com/sources/latests?page=${request.page}&size=${request.size}`
    );
    // return of(this.getFakeSources()).pipe(delay(1000));
  }

  postSectorReport(idSection: number, request: any): Observable<any> {
    return this._http.post<any>(`https://test.reports.brainyinteligencia.com/templates/${idSection}/reports`, request);
  }

  putSectorReport(idSection: number, idReport: number, request: any): Observable<any> {
    return this._http.put<any>(
      `https://test.reports.brainyinteligencia.com/templates/${idSection}/${idReport}`,
      request
    );
  }

  deleteSectorReport(request: any): Observable<Blob> {
    return this._http.delete<any>(
      `https://test.reports.brainyinteligencia.com/templates/${request.id}/${request.idReport}`
    );
  }

  getTemplates(request: any): Observable<any> {
    if (request.categoryId && request.categoryId != 0 && request.categoryId != 'create') {
      return this._http.get<any>(
        `https://test.reports.brainyinteligencia.com/templates?page=${request.page}&size=${request.size}&category_id=${request.categoryId}`
      );
    } else {
      return this._http.get<any>(
        `https://test.reports.brainyinteligencia.com/templates?page=${request.page}&size=${request.size}`
      );
    }

    // return of(this.getFakeSectorReports()).pipe(delay(1000));
  }

  getTemplate(id: number): Observable<any> {
    return this._http.get<any>(`https://test.reports.brainyinteligencia.com/templates/${id}`);
    // return of(this.getFakeSectorReport()).pipe(delay(1000));
  }

  postTemplate(request: any): Observable<any> {
    return this._http.post<any>(`https://test.reports.brainyinteligencia.com/templates`, request);
  }

  putTemplate(request: any): Observable<any> {
    return this._http.put<any>(`https://test.reports.brainyinteligencia.com/templates/${request.id}`, request);
  }

  deleteTemplate(request: any): Observable<any> {
    return this._http.delete<any>(`https://test.reports.brainyinteligencia.com/templates/${request.id}`);
  }

  generateDoc(request: any): Observable<any> {
    // return this._http.get<Blob>(`/templates/${request.idSection}/${request.idReport}/generate`, {
    //   responseType: 'blob' as 'json',
    // });

    return this._http.get<any>(
      `https://test.reports.brainyinteligencia.com/templates/${request.idSection}/${request.idReport}/generate`
    );
  }

  exportDoc(request: any): Observable<Blob> {
    return this._http.get<Blob>(
      `https://test.reports.brainyinteligencia.com/templates/${request.idSection}/${request.idReport}/doc`,
      {
        responseType: 'blob' as 'json',
      }
    );
  }

  postQuestion(request: any): Observable<any> {
    return this._http.post<any>(`https://test.reports.brainyinteligencia.com/prompt`, request);
  }

  getFakeSectorReports(): { page: number; total: number; size: number; items: { id: number; title: string }[] } {
    return {
      page: 1,
      total: 3,
      size: 30,
      items: [
        {
          id: 1,
          title: 'Title 1',
        },
        {
          id: 2,
          title: 'Title 2',
        },
        {
          id: 3,
          title: 'Title 3',
        },
      ],
    };
  }

  getFakeSectorReport(): any {
    return {
      id: 1,
      title: 'Title 1',
      reports: [
        {
          id: 1,
          title: 'Report 1',
          source: 1,
          text: '<p>1 ¿Qué es Lorem Ipsum?</p><p>Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p>',
        },
      ],
    };
  }

  getFakeSources(): any {
    return {
      page: 1,
      total: 3,
      size: 30,
      items: [
        {
          id: 1,
          title: 'Source 1',
          text: '<p>1 ¿Qué es Lorem Ipsum?</p><p>Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p>',
        },
        {
          id: 2,
          title: 'Source 2',
          text: '<p>2 ¿Qué es Lorem Ipsum?</p><p>Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p>',
        },
        {
          id: 3,
          title: 'Source 3',
          text: '<p>3 ¿Qué es Lorem Ipsum?</p><p>Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p>',
        },
      ],
    };
  }
}
